import { render, staticRenderFns } from "./TourComponent.vue?vue&type=template&id=50ece39a&scoped=true"
import script from "./TourComponent.vue?vue&type=script&lang=js"
export * from "./TourComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ece39a",
  null
  
)

export default component.exports